export default "__VITE_PUBLIC_ASSET__12b28c5e__"